"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneInputManager = void 0;
var _i18n = require("@ori/i18n");
var _PhoneManager = require("./PhoneManager");
var _constants = require("./constants");
var _defaultTranslations = require("./constants/defaultTranslations");
var _contexts = require("./contexts");
var _jsxRuntime = require("react/jsx-runtime");
const PhoneInputManager = ({
  customTenant,
  sectionType = _constants.SectionType.Profile,
  currentCustomerId
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
  namespace: _defaultTranslations.translationsNamespace,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.NotificationProvider, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.PhoneProvider, {
      customTenant: customTenant,
      currentCustomerId: currentCustomerId,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PhoneManager.PhoneManager, {
        sectionType: sectionType
      })
    })
  })
});
exports.PhoneInputManager = PhoneInputManager;
